import { CHECKOUT_ITEM_TYPE_FLIGHT } from 'constants/checkout'

export function isFlightItem(item: App.Checkout.Item): item is App.Checkout.FlightItem {
  return item.itemType === CHECKOUT_ITEM_TYPE_FLIGHT
}

export function flightItemIsReady(item: App.Checkout.FlightItem): boolean {
  return (
    !!item.searchId &&
    !!item.journeyType
  )
}
